app.controller('BrowseProductListSolutionController', ['$rootScope', '$scope', '$bootstrapModal', function ($rootScope, $scope, $bootstrapModal) {

    const navigationIDs = $scope.navigation_ids;

    $scope.product_model = $rootScope.factory.product_solution.getModel(navigationIDs);
    $scope.product_model.apiRequire()

    $scope.list_item_include = "views/browse/product/browse-product-item-solution.htm";
    $scope.list_current_txt = "Current Cabinet Type";

    $scope.isProductFiltered = function (selectID, product) {
        const parentCategoryID = navigationIDs.parent_category_id;
        if (parentCategoryID) {
            if (!product.parent_category_ids || !product.parent_category_ids.includes(parentCategoryID)) {
                return true;
            }
        }
        const alphaCategoryID = navigationIDs.alpha_category_id ? navigationIDs.alpha_category_id : selectID;
        if (alphaCategoryID) {
            if (!product.alpha_category_ids || !product.alpha_category_ids.includes(alphaCategoryID)) {
                return true;
            }
        }
        return false;
    }

}]);